import React from "react";
import { Grid, GridColumn, GridRow, LabeledText } from "sprint-common-web";

import { OrderRequestSectionWrapper } from "../components/OrderRequestSectionWrapper";

interface OrderRequestMaterialSpecificationSectionProps {
    minHeight: number;
}

export const OrderRequestMaterialSpecificationSection = ({
    minHeight
}: OrderRequestMaterialSpecificationSectionProps): JSX.Element => {
    return (
        <OrderRequestSectionWrapper
            header="Material specification"
            style={{ minHeight, flex: 1 }}
            testId={"order-request-material-specification-section"}
        >
            {(orderRequest) => (
                <Grid>
                    <GridRow>
                        <GridColumn lg={6}>
                            <LabeledText
                                label="Encoding format"
                                testId="order-encodingFormat"
                                value={orderRequest.materialSpecification?.encodingFormat}
                            />
                            <LabeledText
                                label="Aspect ratio"
                                testId="order-aspectRatio"
                                value={orderRequest.materialSpecification?.aspectRatio}
                            />
                            <LabeledText
                                label="Runtime"
                                testId="order-runtime"
                                value={orderRequest.materialSpecification?.runtime}
                            />
                        </GridColumn>
                        <GridColumn lg={6}>
                            <LabeledText
                                label="Bit rate"
                                testId="order-bitRate"
                                value={orderRequest.materialSpecification?.bitRate}
                            />
                            <LabeledText
                                label="Resolution"
                                testId="order-resolution"
                                value={orderRequest.materialSpecification?.resolution}
                            />
                            <LabeledText label="Notes" testId="order-notes" value={orderRequest.notes} nowrap={false} />
                        </GridColumn>
                    </GridRow>
                </Grid>
            )}
        </OrderRequestSectionWrapper>
    );
};
